import React from 'react';
import { Card, Button, Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const PageHeader = ({ title, onBack }) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <Container fluid>
      <Card className="mt-2">
        <Card.Body>
          <Row className="align-items-center">
            <Col md="auto">
              <Button variant="outline-secondary" size="sm" onClick={handleBack}>
                <i className="fas fa-arrow-left me-2"></i>Back
              </Button>
            </Col>
            <Col>
              <h4 className="mb-0">{title}</h4>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default PageHeader;
